import * as z from "zod";

export const updateDashboardMetricsSettings = {
  name: "updateDashboardMetricsSettings" as const,
  input: z.object({
    metrics: z.array(
      z.object({ key: z.string(), displayed: z.boolean(), order: z.number() }),
    ),
  }),
  output: z.object({ success: z.boolean() }),
};
